import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import React from 'react';
import SyncingProgress
  from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/AggregatorButtonPicker/Yodlee/YodleeLinkContent/SyncingProgress';
import { usePlaidLinkContext } from './PlaidLinkContext';

const styles = () => ({
  root: {},
});

const PlaidLinkContent = ({
  className,
  classes,
  resource,
  renderButtonComponentChildren,
  ButtonComponent,
  ButtonComponentProps,
}) => {
  const {
    handleClick,
    isInitialized,
    isSyncing,
  } = usePlaidLinkContext();

  return (
    <div className={classNames(classes.root, className)}>
      <ButtonComponent
        {...ButtonComponentProps}
        className={classNames(classes.root, className)}
        disabled={!isInitialized}
        onClick={handleClick}
      >
        {renderButtonComponentChildren(resource)}
      </ButtonComponent>
      {isSyncing && <SyncingProgress
        message={'Syncing your account information...'}
      />}
    </div>
  );
};

PlaidLinkContent.defaultProps = {
  className: '',
};

PlaidLinkContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  renderButtonComponentChildren: PropTypes.func.isRequired,
  ButtonComponent: PropTypes.object.isRequired,
  ButtonComponentProps: PropTypes.object.isRequired,
};

export default withStyles(styles)(PlaidLinkContent);
